import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=26d22682&scoped=true"
import script from "./BasicTable.vue?vue&type=script&lang=js"
export * from "./BasicTable.vue?vue&type=script&lang=js"
import style0 from "./BasicTable.vue?vue&type=style&index=0&id=26d22682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d22682",
  null
  
)

export default component.exports